<template>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	created() {

	},
	methods: {
		handleScroll: function(e)  {

		}
	}
}
</script>
<style scoped></style>